module.exports = __webpack_public_path__ + "static/img/btn_chat_call.44cd4c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_chat_call.png
// module id = Vzbt
// module chunks = 1